<template>
  <div class="mapInfo father-module flex flex-v">
    <div class="title-module">
      <img src="@/assets/image/layout/mod-title.png" alt="" class="title-module-img" />
      桥梁信息
    </div>
    <div class="flex-1 mod-bd">
      <div style="display: flex; justify-content: center; align-items: center">
        <div
          style="width: 100%; text-align: center; margin-top: 10px"
          v-if="infowData.scenePictureUrl"
        >
          <el-image
            style="width: 100%; height: 100%; border-radius: 5px; overflow: hidden"
            :src="infowData.scenePictureUrl[0]"
            :preview-src-list="infowData.scenePictureUrl"
          ></el-image>
        </div>
        <!-- <div style="margin-top: 10px">
          <img
            src="@/assets/image/layout/demo.jpg"
            alt=""
            style="
              width: 100%;
              border-radius: 4px;
              overflow: hidden;
              border: 1px solid #707070;
            "
          />
        </div> -->
      </div>
      <div class="baseinfo">
        <div class="name">{{ infowData.bridgeName }}</div>
        <div class="addr flex flex-align-center mt10">
          <img src="@/assets/image/layout/addr.png" alt="" />
          <span>{{ infowData.address }}</span>
        </div>
        <img class="mt8" src="@/assets/image/layout/line.png" alt="" />
        <div class="mt10">归属区域：{{ infowData.ascriptionName }}</div>
        <div class="flex flex-align-center mt10">
          <div>经度：{{ infowData.longitude }}</div>
          <div class="ml40">纬度：{{ infowData.latitude }}</div>
        </div>
        <div class="mt10">巡检单位：{{ infowData.curingUtil }}</div>
        <div class="flex flex-align-center mt10">
          <div>巡查周期：{{ infowData.inspectionCycle }}</div>
          <div class="ml40">开始时间：{{ infowData.inspectionCycleStart }}</div>
        </div>
        <img class="mt10" src="@/assets/image/layout/line.png" alt="" />
        <div class="mt8" v-html="infowData.introduce"></div>
        <img class="mt8" src="@/assets/image/layout/line.png" alt="" />
        <el-table
          class="mt8"
          :data="infowData.biEquipmentList"
          :row-class-name="tableRowClassName"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label="编号"
            fixed="left"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="equipmentAnotherName"
            label="设备别名"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="equipmentCode"
            width="120"
            label="设备编码"
          ></el-table-column>
          <!-- <el-table-column prop="sim" width="120" label="SIM卡号"></el-table-column> -->
          <el-table-column prop="address" label="预警值">
            <template #default="scope">
              <div class="warning-value">
                <div>{{ scope.row.beginWarningValue }}</div>
                <div class="input-line"></div>
                <div>{{ scope.row.endWarningValue }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="equipmentTypeName"
            width="120"
            label="设备类型"
          ></el-table-column>
          <!-- <el-table-column prop="communicationChannel" width="120" label="通信通道"></el-table-column> -->
          <el-table-column prop="status" fixed="right" label="状态">
            <template #default="scope">
              <div :class="!scope.row.status ? '' : 'isStatus'" class="default-status">
                <div
                  :class="!scope.row.status ? '' : 'isCircle'"
                  class="circle-div"
                ></div>
                <div>{{ !scope.row.status ? '离线' : '在线' }}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <img class="mt20" width="100%" src="@/assets/image/layout/line.png" alt="" />
      <div>
        <!-- <span class="shubian"></span> -->
        <h4 class="biaoti">照片</h4>
        <div
          v-if="infowData.scenePictureUrl && infowData.scenePictureUrl.length > 0"
          style="display: flex; flex-wrap: wrap"
        >
          <div
            v-for="item in infowData.scenePictureUrl"
            :key="item"
            style="width: 140px; height: 140px; margin-bottom: 10px; margin-right: 15px"
          >
            <el-image
              style="width: 100%; height: 100%; border-radius: 5px; overflow: hidden"
              :src="item"
              :preview-src-list="[item]"
            ></el-image>
          </div>
        </div>
      </div>
      <img class="mt20" width="100%" src="@/assets/image/layout/line.png" alt="" />
      <div style="width: 100%">
        <h4 class="biaoti">档案</h4>
        <div>
          <el-row>
            <el-col :span="8">
              <div class="dangan">设计档案</div>
              <div
                style="margin-top: 10px"
                v-if="
                  infowData.designDocumentUrl && infowData.designDocumentUrl.length > 0
                "
              >
                <div
                  style="margin-top: 5px"
                  v-for="(item, index) in infowData.designDocumentUrl.split(',')"
                  :key="index"
                >
                  <img
                    src="@/assets/image/old/文件夹@2x.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 5px"
                  />
                  <a
                    href="javascript:void(0);"
                    @click="detailsRow(item)"
                    style="color: #fff; word-wrap: break-word"
                    >{{ item }}</a
                  >
                </div>
              </div>
            </el-col>
            <el-col :span="8" style="padding-left: 20px">
              <div>检测档案</div>
              <div
                style="margin-top: 10px"
                v-if="infowData.checkDocumentUrl && infowData.checkDocumentUrl.length > 0"
              >
                <div
                  style="margin-top: 5px"
                  v-for="(item, index) in infowData.checkDocumentUrl.split(',')"
                  :key="index"
                >
                  <img
                    src="@/assets/image/old/文件夹@2x.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 5px"
                  />
                  <a
                    href="javascript:void(0);"
                    @click="detailsRow(item)"
                    style="color: #fff; word-wrap: break-word"
                    >{{ item }}</a
                  >
                </div>
              </div>
            </el-col>
            <el-col :span="8" style="padding-left: 20px">
              <div>巡检档案</div>
              <div
                style="margin-top: 10px"
                v-if="
                  infowData.inspectionDocumentUrl &&
                  infowData.inspectionDocumentUrl.length > 0
                "
              >
                <div
                  style="margin-top: 5px"
                  v-for="(item, index) in infowData.inspectionDocumentUrl.split(',')"
                  :key="index"
                >
                  <img
                    src="@/assets/image/old/文件夹@2x.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 5px"
                  />
                  <a
                    href="javascript:void(0);"
                    @click="detailsRow(item)"
                    style="color: #fff; word-wrap: break-word"
                    >{{ item }}</a
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <img class="mt20" width="100%" src="@/assets/image/layout/line.png" alt="" />
      <div>
        <h4 class="biaoti">健康状态</h4>
        <div style="margin-bottom: 10px">
          桥梁状态：
          <span style="color: #6ecad2">{{ infowData.status }}</span>
        </div>
        <div>
          <span style="display: inline-block">评判标准：</span>
          <div style="display: inline-block; color: #666">
            {{ infowData.criteria }}
          </div>
        </div>
      </div>
      <img class="mt20" width="100%" src="@/assets/image/layout/line.png" alt="" />
      <div>
        <h4 class="biaoti">一桥一档</h4>
        <div>
          <el-image
            style="width: 170px; height: 170px; border-radius: 5px; overflow: hidden"
            :src="infowData.bridgePicture"
            :preview-src-list="[infowData.bridgePicture]"
          ></el-image>
        </div>
      </div>
      <div style="margin-left: 10px" v-if="false">
        <div>
          <span class="shubian"></span>
          <div class="biaoti" style="margin-top: 0px">基本信息</div>
          <div class="xinxi">
            <div>
              桥梁名称：
              <span style="color: #6ecad2">{{ infowData.bridgeName }}</span>
            </div>
            <div>
              地址：
              <span style="color: #6ecad2">{{ infowData.address }}</span>
            </div>
            <div>归属区域：{{ infowData.ascriptionName }}</div>
            <div>经度：{{ infowData.longitude }}</div>
            <div>纬度：{{ infowData.latitude }}</div>
            <div>巡检单位：{{ infowData.curingUtil }}</div>
            <div>巡查周期：{{ infowData.inspectionCycle }}</div>
            <div>开始时间：{{ infowData.inspectionCycleStart }}</div>
          </div>
          <div>
            <span style="display: inline-block; margin-right: 26px">介绍：</span>
            <div style="display: inline-block; color: #fff">
              {{ infowData.introduce }}
            </div>
          </div>
        </div>
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti">设备配置</h4>
          <el-table
            :data="infowData.biEquipmentList"
            height="260"
            style="width: 100%; border-radius: 5px"
            :row-class-name="tableRowClassName"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column
              type="index"
              label="编号"
              fixed="left"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="equipmentAnotherName"
              label="设备别名"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="equipmentCode"
              width="120"
              label="设备编码"
            ></el-table-column>
            <el-table-column prop="sim" width="120" label="SIM卡号"></el-table-column>
            <el-table-column prop="address" label="预警值">
              <template #default="scope">
                <div class="warning-value">
                  <div>{{ scope.row.beginWarningValue }}</div>
                  <div class="input-line"></div>
                  <div>{{ scope.row.endWarningValue }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="equipmentTypeName"
              width="120"
              label="设备类型"
            ></el-table-column>
            <el-table-column
              prop="communicationChannel"
              width="120"
              label="通信通道"
            ></el-table-column>
            <el-table-column prop="status" fixed="right" label="状态">
              <template #default="scope">
                <div :class="!scope.row.status ? '' : 'isStatus'" class="default-status">
                  <div
                    :class="!scope.row.status ? '' : 'isCircle'"
                    class="circle-div"
                  ></div>
                  <div>{{ !scope.row.status ? '离线' : '在线' }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="mod-ft flex flex-align-center">
      <el-button
        type="primary"
        v-if="this.$route.path.indexOf('facility') == -1"
        class="details"
        @click="goBim(infowData)"
        >查看详情</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelMapInfo',
  props: ['infowData'],
  data() {
    return {
      time: '',
      times: null
    };
  },

  mounted() {
    this.timechange();
    // console.log('详情的设施详情', this.infowData);
  },

  methods: {
    //下载
    detailsRow(data) {
      console.log('下载数据', data);
      const a = document.createElement('a');
      a.href = data.fileUrl;
      // a.download = '文件名1'; // 下载后文件名
      a.setAttribute('download', data.fileName);
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click(); // 点击下载
      document.body.removeChild(a); // 下载完成移除元素
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'success-row';
      } else {
        return 'warning-row';
      }
    },
    //时间
    timechange(date, fmt) {
      Date.prototype.Format = function (fmt) {
        var o = {
          'M+': this.getMonth() + 1, //月份
          'd+': this.getDate(), //日
          'H+': this.getHours(), //小时
          'm+': this.getMinutes(), //分
          's+': this.getSeconds(), //秒
          'q+': Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
        return fmt;
      };
    },
    goBim(e) {
      this.$router.push(`/facility/${e.bridgeUuid}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.mapInfo {
  width: 460px;
  height: 800px;
  overflow-y: scroll;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
}

.mt8 {
  margin-top: 8px;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.ml40 {
  margin-left: 40px;
}

.mod-bd {
  min-height: 0;
  overflow: auto;
  font-size: 14px;
  color: #dedede;

  .baseinfo {
    margin-top: 16px;

    img {
      display: block;
      width: 100%;
    }

    .name {
      font-weight: 800;
      font-size: 16px;
      color: #fff;
    }

    .addr {
      font-size: 16px;

      img {
        margin-right: 6px;
        width: 12px;
        height: 14px;
      }
    }
  }
}

.mod-ft {
  border-top: 1px solid #0c41b3;
  height: 48px;

  .details {
    background: linear-gradient(180deg, #125cd6 0%, #094bbf 100%);
    border-radius: 4px;
    width: 135px;
    height: 31px;
    font-size: 14px;
    line-height: 31px;
    margin: 0 auto;
    padding: 0;
    display: block;
    border: none;
  }
}

// div {
// padding: 10px 0 10px 10px;
// padding-left: 10px;
// }
.shubian {
  width: 3px;
  height: 16px;
  background: linear-gradient(0deg, #20b9b9 0%, #83f4fe 100%);
  border-radius: 2px;
  display: inline-block;
}

.input-line {
  margin: 0 10px;
  width: 30px;
  border-bottom: 1px solid #999999;
}

.xinxi {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}

.xinxi > div {
  margin-right: 40px;
  margin-bottom: 10px;
}

.biaoti {
  display: inline-block;
  // margin-left: 10px;
  margin-top: 12px;
  margin-bottom: 5px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #fff;
  line-height: 50px;
}

::v-deep .el-table thead {
  color: #fff;
}

::v-deep .el-table th.el-table__cell {
  // background-color: #6ecad2;
  // border-left: 1px solid #52a8b0;
  color: #fff;
  height: 50px;
}

::v-deep .el-table__fixed-right {
  background: linear-gradient(265deg, #0199ef 0%, #013f86 100%);
}

::v-deep .el-table__fixed-right-patch {
  width: 0 !important;
}

::v-deep .el-table .warning-row {
  background: rgba(1, 147, 229, 0.5);
}

::v-deep .el-table .success-row {
  // background: #eef6f7;
}

::v-deep .el-table .cell {
  // color: #000;
}

::v-deep .el-table tr.hover-row > td.el-table__cell {
  background: rgba(255, 255, 255, 0.2);
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/deep/ .el-table__header-wrapper {
  border: 1px solid #0270ad;
  background: linear-gradient(
    265deg,
    rgba(1, 153, 239, 0.5) 0%,
    rgba(1, 63, 134, 0.5) 100%
  );
  line-height: 50px;
}

/deep/.el-table th.el-table__cell > .cell,
/deep/ .el-table td.el-table__cell div {
  font-size: 14px;
}
</style>
